var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetAccent600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 21C17.1895 21 21.6666 16.5228 21.6666 11C21.6666 5.47715 17.1895 1 11.6666 1C6.14378 1 1.66663 5.47715 1.66663 11C1.66663 16.5228 6.14378 21 11.6666 21Z",
    stroke: "#648CE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 17C14.9803 17 17.6666 14.3137 17.6666 11C17.6666 7.68629 14.9803 5 11.6666 5C8.35292 5 5.66663 7.68629 5.66663 11C5.66663 14.3137 8.35292 17 11.6666 17Z",
    stroke: "#648CE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 13C12.7712 13 13.6666 12.1046 13.6666 11C13.6666 9.89543 12.7712 9 11.6666 9C10.5621 9 9.66663 9.89543 9.66663 11C9.66663 12.1046 10.5621 13 11.6666 13Z",
    stroke: "#648CE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetAccent600);
export default __webpack_public_path__ + "static/media/target-accent600.d9e8a4316bedc5c64b31dc2442d65f7e.svg";
export { ForwardRef as ReactComponent };